import React from "react";

import Grid from "@material-ui/core/Grid";

import FilterReportAccountant from "./FilterReportAccountant";
import ButtonsXML from "./ButtonsAccountant";
import DataTable from "./DataTableAccountant";
import "./reportAccountant.css";
import { ReportAccountantContextProvider } from "../../context/ReportAccountantContext";

const View = () => {
  return (
    <Grid container alignItems="center" justify="center">
      <Grid
        item
        container
        alignItems="flex-start"
        justify="center"
        xs={11}
        spacing={1}
      >
        <Grid item xs={12}>
          <FilterReportAccountant />
        </Grid>

        <Grid item lg={8} md={7} sm={12} xs={12}>
          <DataTable />
        </Grid>

        <Grid item lg={4} md={5} sm={12} xs={12}>
          <ButtonsXML />
        </Grid>
      </Grid>
    </Grid>
  );
};

const PreviewReportAccountant = (props) => (
  <ReportAccountantContextProvider>
    <View {...props} />
  </ReportAccountantContextProvider>
);

export { PreviewReportAccountant };
